/** Unified CRM deal deep link: ?deal=order:123 | ?deal=lead:456 */
export type CrmOpenDeal = { kind: 'order' | 'lead'; id: number };

export type CrmDealSnapshot = {
  orderCard?: import('../../../api').CrmPipelineCard;
  leadCard?: import('../../../api').CrmLeadCard;
};

export type CrmOpenDealOptions = {
  focusTasks?: boolean;
};

export type CrmOpenDealHandler = (
  deal: CrmOpenDeal,
  snapshot?: CrmDealSnapshot,
  options?: CrmOpenDealOptions,
) => void;

export function parseCrmDealParam(raw: string | null | undefined): CrmOpenDeal | null {
  if (!raw?.trim()) return null;
  const m = raw.trim().match(/^(order|lead):(\d+)$/i);
  if (!m) return null;
  const id = Number(m[2]);
  if (!Number.isFinite(id) || id <= 0) return null;
  return { kind: m[1].toLowerCase() as 'order' | 'lead', id };
}

export function formatCrmDealParam(deal: CrmOpenDeal): string {
  return `${deal.kind}:${deal.id}`;
}

export function sameCrmOpenDeal(a: CrmOpenDeal | null | undefined, b: CrmOpenDeal | null | undefined): boolean {
  return Boolean(a && b && a.kind === b.kind && a.id === b.id);
}

/** Legacy ?order= / ?lead= query params */
export function crmOpenDealFromLegacySearch(params: URLSearchParams): CrmOpenDeal | null {
  const dealRaw = params.get('deal');
  const fromDeal = parseCrmDealParam(dealRaw);
  if (fromDeal) return fromDeal;
  const orderRaw = params.get('order');
  const orderId = orderRaw ? Number(orderRaw) : NaN;
  if (Number.isFinite(orderId) && orderId > 0) return { kind: 'order', id: orderId };
  const leadRaw = params.get('lead');
  const leadId = leadRaw ? Number(leadRaw) : NaN;
  if (Number.isFinite(leadId) && leadId > 0) return { kind: 'lead', id: leadId };
  return null;
}

export function crmDealSearchKeysToClear(): string[] {
  return ['deal', 'order', 'lead', 'claim'];
}
